/** A queued drop's capture time, for save_pick_tallies (mig 20261024390000).
 *  The capture screen stamps `captured_at` on every row; an entry queued
 *  before that shipped has none, and the nearest truth we hold for it is when
 *  it was queued — which is when it was captured, since a queued drop is one
 *  the device could not send at the time. A row's own stamp always wins. */
export function withCapturedAt(
  tallies: ReadonlyArray<Record<string, unknown>>, queuedAt: string,
): Record<string, unknown>[] {
  return tallies.map(t => ({ captured_at: queuedAt, ...t }))
}
